import { MenuRenderer } from 'components/menu';
import MenuStyles from 'components/menu/Menu.module.scss';
import { GlamboxSessionStore } from 'core/glambox/GlamboxSessionStore';
import { MenuData } from 'core/menu';
import { HasActiveSubscriber, showPortalGp } from 'core/utils/SubscriberUtils';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// MENUS
//#region
import { StateActions } from 'state/actions/StateActions';
import { UiActions } from 'state/actions/UiActions';
import { ExecuteToggle } from 'state/ducks/Modals';
//#endregion
import classnames from 'classnames';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';

class NewMenuBody extends Component {
  menu = {
    nonSubscriber: null,
    subscriber: null,
    glampartner: null,
    glampartnerPortal: null,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getMenuData();
  }

  componentDidUpdate(prevProps) {
    const { person } = this.props;
    if (
      prevProps.token.Authorization !== this.props.token.Authorization ||
      person.subs !== prevProps.person.subs
    ) {
      this.getMenuData();
    }
  }

  getMenuData = () => {
    const menuContent = {
      nonSubscriber: () => {
        this.setMenuState(MenuData.MenuNonSubscriber);
      },
      activeSubscriber: () => {
        this.setMenuState(MenuData.MenuActiveSubscriber);
      },
      inactiveSubscriber: () => {
        this.setMenuState(MenuData.MenuInactiveSubscriber);
      },
      portal: () => {
        this.setMenuState(MenuData.MenuPortal);
      },
      glampartner: () => {
        this.setMenuState(MenuData.MenuGlampartner);
      },
      admin: () => {
        this.setMenuState(MenuData.MenuAdmin);
      },
    };

    let { person } = this.props;
    let { personStatus } = person.person;

    if (!person.subs || person.subs.length < 1) {
      const menuNonSubs = menuContent['nonSubscriber'];
      menuNonSubs();
    } else {
      let hasActive = HasActiveSubscriber(person.subs);
      if (hasActive) {
        menuContent['activeSubscriber']();
      } else {
        menuContent['inactiveSubscriber']();
      }
    }

    if (personStatus !== undefined && personStatus === 14) {
      let session = new GlamboxSessionStore();
      let comesFromGpSite = session.get('isGlampartner');

      if (comesFromGpSite) {
        const menuPortalGp = menuContent['portal'];
        menuPortalGp();
      } else {
        const menuGp = menuContent['glampartner'];
        menuGp();
      }
    }

    this.props.isAdmin(person.person.username, response => {
      const isAdmin = response.result;
      if (isAdmin) {
        menuContent['admin']();
      }
    });
  };

  setMenuState = menuData => {
    let menu = this.bootstrapMenu(menuData);
    this.setState({ menu });
  };

  bootstrapMenu = menuData => {
    let menu = [...menuData];
    for (let item of menu) {
      item = this.bootstrapMenuItem(item);
    }
    return menu;
  };

  bootstrapMenuItem = item => {
    const { person } = this.props;

    switch (item.path) {
      case '/magica-do-cookie':
        if (
          person.person.username === 'tecnologia@b4agroup.com' ||
          person.person.username === 'suporte@weclever.co'
        ) {
          item.active = true;
        } else {
          item.active = false;
        }
        break;
      case '/admin/resultados':
      case 'admin/campaigns':
      case 'admin/influencers':
      case 'admin/payments':
        this.props.isAdmin(person.person.username, response => {
          const isAdmin = response.result;
          if (!isAdmin) {
            item.active = true;
          } else {
            item.active = false;
          }
        });
        break;
      case '/glampartner':
        item.onClick = evt => {
          const { href } = evt.currentTarget;

          !showPortalGp() && window.open(href, '_blank');
        };
        break;
      case '/':
        item.onClick = evt => {
          const { href } = evt.currentTarget;

          showPortalGp() && window.open(href, '_blank');
        };
        break;
      case '/perfil-de-beleza':
        item.onClick = event => {
          if (event.preventDefault) event.preventDefault();
          this.props.toggle('beautyProfile');
        };
        break;
      case '//glamshop.com.br':
        //  item.className = MenuStyles["glamshop"];
        break;
      default:
        item.onClick = () => {};
    }

    if (Array.isArray(item.children) && item.children.length > 0) {
      item.children = this.bootstrapMenu(item.children);
    }

    return item;
  };

  render() {
    const { props, state } = this;

    if (!state) return null;

    const { badge } = props.person;

    let badgeId = badge ? badge.badgeId : null;
    return (
      <>
        <MenuRenderer
          menu={this.state.menu}
          badgeId={badgeId}
          className={MenuStyles['menu']}
        />
      </>
    );
  }
}

const mapMenuBodyState = state => ({
  person: state.person.data,
  token: state.token.data,
});

const mapMenuBodyDispatch = dispatch => ({
  closeMenu: () => {
    dispatch(UiActions.menuHide());
  },
  togglePortaGlampartners: isActive => {
    dispatch(StateActions.portalGlampartnersIsActive(isActive));
  },
  toggle: name => {
    dispatch(ExecuteToggle(name));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  },
});

NewMenuBody = connect(mapMenuBodyState, mapMenuBodyDispatch)(NewMenuBody);

NewMenuBody = withRouter(NewMenuBody);

export { NewMenuBody };
